/* eslint-disable import/prefer-default-export */
import { useShopConfig } from './shopConfig';
import { getEnabledCustomerExperiences } from '../shopConfig/configHelper';

export const useEnabledCustomerExperiences = () => {
  // TODO (TREET-4009) Type enabledCustomerExperiences from contentful
  const { enabledCustomerExperiences: experiencesFromConfig, wasBuyEnabled } = useShopConfig();
  return getEnabledCustomerExperiences(experiencesFromConfig, wasBuyEnabled);
};
